import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehicleKilometersTotal from './ReportVehicleKilometersTotal'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportVehicleKilometersTotal} />
    </Switch>
)

export default Components
